import React from 'react';

//components
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { BasicCheckbox } from 'thrive-components';

//helpers
import { Truncate } from  '@/helpers/Text';
import { BuildPath } from  '@/helpers/Paths';

//interfaces
import { TranslatedStatus } from  '@/interfaces/ContentTranslations';


interface LanguageCardProps {
    languageCode: string
    name: string
    enabled: boolean
    translationStatus: number
    index: number,
    previousTranslationExists: boolean,
    flagRegionCode: string,
    toggleLanguage: (code: string) => void;
}

const FlagCard = ({languageCode, name, enabled, translationStatus, index, toggleLanguage, previousTranslationExists, flagRegionCode}: LanguageCardProps) => {

    function getPositionStyle(idx: number) {
        const mod = idx % 4;
        if (mod === 1) {
            return {marginLeft: 0}
        }
        else if (mod === 0) {
            return {marginRight: 0}
        }
        return {}
    }

    function getTranslationStatusClass(index: number): string {
        return ['not', 'translating', 'success', 'failed'][index];
    }

    function TranslationStatus () {
        switch(translationStatus) {
            case TranslatedStatus.Translating:
                return <p className={`translation-status`}>Translating...</p>
            case TranslatedStatus.Success:
                return <p className={`translation-status success`}>Success</p>
            case TranslatedStatus.Failed:
                return <p className={`translation-status failed`}>Failed</p>
            default:
                return <p className={`translation-status`}>Not Translated</p>
        }
    }

    function getFlag(flagRegionCode: string) {
        return `${BuildPath()}/images/translations/Flags/${flagRegionCode?.toLowerCase() ?? "flagNotFound"}.svg`
    }
    
    const flagStyle = {
        backgroundImage: `url(${getFlag(flagRegionCode)}), url(${BuildPath()}/images/translations/Flags/flagNotFound.svg)`, 
        backgroundRepeat: 'no-repeat, no-repeat', 
        backgroundSize: 'cover, 108px', 
        backgroundPosition: 'center, center'
    }

    return ( 
        <li
            key={`toggle-language-${languageCode}`}
            className={`language-selector ${getTranslationStatusClass(translationStatus)}`}
            style={getPositionStyle(index + 1)}
        >
            <div className="select-wrapper" >
                {name.length >= 12 &&
                    <ReactTooltip id={`tooltip-language-${languageCode}`} place="top" className='thrive-tooltip no-width' aria-hidden="true">
                        <span>{name}</span>
                    </ReactTooltip> 
                }

                <label tab-index={0} data-tooltip-id={`tooltip-language-${languageCode}`} htmlFor={`toggle-language-${languageCode}`}>
                    <div className='flag' style={flagStyle}>&nbsp;</div>
                    
                    <span className="checkbox-and-label">
                        {Truncate(name, 12)}
                    
                        <BasicCheckbox id={`toggle-language-${languageCode}`} isChecked={enabled} onChange={() => toggleLanguage(languageCode)} label={name} ariaLabel={name}/>
                    </span>
                </label>    
            </div>

            <TranslationStatus />
            
            {previousTranslationExists && <>
                <ReactTooltip id={`tooltip-language-${languageCode}-is-translated`} place="top" className='thrive-tooltip no-width'  aria-hidden="true">
                    <span>This is an out-of-date translation. Enable the language and publish to update this translation.</span>
                </ReactTooltip>
                <div 
                    data-tip
                    data-tooltip-id={`tooltip-language-${languageCode}-is-translated`} 
                    style={{
                        position: 'absolute',
                        bottom: '6px',
                        right: '6px',
                        background: 'linear-gradient(125deg, rgb(110, 184, 29) 53%, rgb(187, 197, 209) 53%)',
                        minWidth: '10px',
                        minHeight: '10px',
                        borderRadius: '50%'
                    }}
                />
            </>}
        </li>
    );
}

export default FlagCard